import { getPageType } from '../javascripts/utils/common';

const gaMap = {
  click: {
    login: {
      hitType: 'event',
      eventCategory: 'Profile',
      eventAction: 'Login_Click',
      eventLabel: '',
    },
    disableAdv: {
      hitType: 'event',
      eventCategory: 'Ads',
      eventAction: 'Header_Turn_off_Click',
      eventLabel: '',
    }
  },
  show: {
    login: {
      hitType: 'event',
      eventCategory: 'Profile',
      eventAction: 'Login_OnShow',
      eventLabel: '',
    },
    disableAdv: {
      hitType: 'event',
      eventCategory: 'Ads',
      eventAction: 'Header_Turn_off_OnShow',
      eventLabel: '',
    }
  }
};

const sendPrimeAnalytics = (action, category) => {
  const gaParams = gaMap[action][category];
  if (gaParams) {
    gaParams.eventLabel = getPageType();
    gaParams && window.sendAnalytics(gaParams);
  }
};

export default sendPrimeAnalytics;



// WEBPACK FOOTER //
// ./daily/assets/id/analytics.js